module.exports = __webpack_public_path__ + "static/img/03.50b02eb4.png";